import { IAttendanceRecord, IAttendanceRecordBase } from "../shared/types";
import { BaseServiceLegacy } from "./base.service.legacy";

export class AttendanceRecordService extends BaseServiceLegacy<
  IAttendanceRecord,
  IAttendanceRecordBase
> {
  constructor() {
    super("/attendance-records");
  }
}
